export default class QuestionTracker {
  CorrectCount: number;
  MissCount: number;
}
